var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-row',[_c('g-master',{ref:"master",attrs:{"name":"forms","endpoint":_vm.master.endpoint,"tableSetup":_vm.master.tableSetup,"actions":false,"modalFieldsSetup":_vm.master.modalFieldsSetup,"parentData":_vm.parentData}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc8ad452","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/customization/GlobalBPOCore/pages/Empleados/EmployeeSocialSecurityHist.vue
// module id = null
// module chunks = 